import * as React from 'react'
import { getPetsWIthDevices } from '../../helpers/dataHelpers.ts'
import { IDevice, IPet } from '../../interfaces/types.ts'
import dataStore from '../../store/dataStore.ts'
import './PetDrawer.css'
import { centerMapOnPet } from '../map/mapHelpers.tsx'
import { Battery } from '../dashboard/components/Battery.tsx'
import { CheckinRateButton } from '../common/buttons/CheckinRateButton.tsx'

import { FindButton } from '../common/buttons/FindButton.tsx'
import { PetEventsButton } from '../common/buttons/PetEventsButton.tsx'
import { fenceIcon } from '../../helpers/colorHelper.ts'
// import { DateTime } from 'luxon'
// import authStore from '../../store/authStore.ts'

const SMALL_SCREEN = 360

// const iconSize = 'xl'
export const MiniPetList: React.FC = () => {
    const petsWithDevices: string[] = getPetsWIthDevices()
    const devices = dataStore(s => s.devices)
    const _pets = dataStore(s => s.pets)
    // const breeds = dataStore(s => s.breeds)
    const pets = _pets.filter(p => petsWithDevices.includes(p._id)).sort((a, b) => a.petName > b.petName ? 1 : -1)

    let imageSize = 60
    if (window.innerWidth < SMALL_SCREEN) {
        imageSize = 40
    }

    const getList = (pets: IPet[], devices: IDevice[]) => {
        return pets.map(pet => {
            const d = devices.find(d1 => d1.petId === pet._id)
            if (!d) {
                return null
            }
            let safeZone = 'In'
            if (d.status.safeZoneViolation) {
                safeZone = 'Out'
            }

            const powerSavingMode = d.status.beaconInRange && d.status.powerOn
            const isCharging = d.status.charging
            let findDisabled= !d?.status.powerOn || powerSavingMode
            findDisabled = isCharging ? false : findDisabled
            findDisabled = d?.status.deviceCommandInProgressStatus ? true : findDisabled
            const safeZoneName = d.status.occupiedZone || 'Safe Zone'
            // const rate = readableSeconds(d.status.backgroundInterval).split(' ')

            // const locationDate = d?.lastLocation?.properties?.receivedTime ? DateTime.fromISO(d.lastLocation.properties.receivedTime)
            //     .setZone(authStore.getState().timezone.value).toLocaleString(DateTime.DATETIME_MED_WITH_WEEKDAY)
            //     : 'No locations received'

            // const displayedDate = (
            //     <div className={'flex flex-col'}>
            //         <div className={'text-primary-content text-md font-semibold ml-12'}>{locationDate}</div>
            //         {/* {off || inPowerSavingMode || staleWarning}*/}
            //     </div>
            // )

            // const inPowerSavingMode = powerSavingMode ?
            //     <div
            //         className={'rounded px-1 h-[14px] m-auto w-fit text-center bg-primary-content text-sm text-accent font-bold leading-[14px]'}>
            //         Power Save Mode
            //     </div>
            //     : null

            // const off = !d.status.powerOn ?
            //     <div
            //         className={'rounded px-1 h-[14px] m-auto w-fit text-center bg-primary-content text-sm text-accent font-bold leading-[14px]'}>
            //         Gibi Off
            //     </div>
            //     : null

            // const inCharger = d.status.charging ?
            //     <div
            //         className={'rounded px-1 h-[14px] m-auto w-fit text-center bg-primary-content text-sm text-accent font-bold leading-[14px]'}>
            //         In Charger
            //     </div>
            //     : null

            const petName = (
                <div className={''}>
                    <div className={'text-primary-content text-3xl font-bold text-left pl-2'}>
                        {pet.petName}
                    </div>
                </div>
            )

            const petAvatar = (
                <div className={'rounded-full border border-2 border-white'}>
                    <div className={'rounded-full border border-4'} style={{borderColor: pet.iconColor}}>
                        <div className={'rounded-full border border-2 border-white cursor-pointer'}
                             onClick={() => console.log(pet)}>
                            <img src={pet.imageURL}
                                 style={{
                                     height: `${imageSize}px`,
                                     width: `${imageSize}px`,
                                     borderRadius: '50%',
                                 }}
                            />
                        </div>
                    </div>
                </div>
            )

            const safeZoneIndicator = (
                <div className={'flex flex-col items-center self-start relative'}>
                    <div
                        className={`font-semibold text-lg flex items-center justify-center rounded-full w-[33.5px] h-[33.5px] border-2 border-white ${safeZone === 'In' ? 'bg-success' : 'bg-gray-400'}`}>
                        <img className={'w-8 mt-2'}
                             src={fenceIcon(safeZone === 'In' ? '#ffffff' : '#fff')}/>
                    </div>
                    <div
                        className={'absolute -bottom-[20px] -left-[14px] w-[65px] overflow-hidden bg-transparent text-primary-content pr-2.5 text-nowrap'}>
                        {safeZoneName}
                    </div>
                </div>
            )

            const batteryIndicator = (
                <div className={'self-start pb-2'}>
                    <Battery pet={pet} iconOnly mobile/>
                </div>
            )

            const beaconIndicator = (
                <div className={'relative h-full flex flex-col gap-1 items-center relative self-start'}>
                    {/*<div*/}
                    {/*    className={'bg-transparent text-primary-content -mt-[14px]'}>*/}
                    {/*    Power*/}
                    {/*</div>*/}
                    <div
                        className={`flex items-center justify-center rounded-full w-[33.5px] h-[33.5px] border-2 border-white ${powerSavingMode ? 'bg-success' : 'bg-gray-400'}`}>

                    </div>
                    <div
                        className={'bg-transparent text-primary-content'}>
                        Pwr Saving
                    </div>
                </div>
            )

            const indicators = (
                <div onClick={() => centerMapOnPet(pet)}>
                    <div
                        className={'flex flex-col p-2 gap-1'}>
                        {petName}
                        <div className={'flex items-center justify-between w-full h-[78px]'}>
                            {petAvatar}
                            <div className={'flex items-center justify-around w-[65%] pt-8'}>
                                {safeZoneIndicator}
                                {beaconIndicator}
                                {batteryIndicator}
                            </div>
                        </div>
                        {/*<div className={'absolute left-[48px] bottom-[10px] w-[59%]'}>*/}
                        {/*    {off}*/}
                        {/*</div>*/}
                    </div>
                </div>
            )

            const buttons = (
                <div className={'h-full py-5'}>
                    <div
                        className={'flex flex-col items-center justify-between h-full w-fit border-l-2 border-l-base-300 pl-3 border-opacity-20'}>
                        <FindButton device={d} disabled={findDisabled}/>
                        <CheckinRateButton tracker={d} outline full textColor={'text-primary-content'}
                                           disabled={findDisabled}/>
                        {/*<PetHistoryButton pet={pet} outline/>*/}
                        <PetEventsButton pet={pet} outline/>
                    </div>
                </div>
            )

            return (
                <div key={pet._id}
                     className={'relative grid grid-cols-[70%_30%] bg-primary text-primary-content rounded-xl mx-1'}>
                    {indicators}
                    {buttons}
                </div>
            )
        })
    }

    const list = React.useMemo(() => {
        if (devices && pets) {
            return getList(pets, devices)
        }
        return []
    }, [devices, pets])

    return <div className={'bg-transparent flex flex-col gap-2'}>{list}</div>
}
